import { ErrorSmallPopup } from '../popups/errorSmallPopup';
import { Localization } from '../localization/localization';

function handleSocialLoginFail() {
    const errorPopup = ErrorSmallPopup.getInstance();
    errorPopup.setMessage(Localization._n('acccount_is_transferred'));
    errorPopup.setButtonText('Ok');
    errorPopup.show();
    errorPopup.setCallback(() => {
        errorPopup.hide();
    });
    return true;
}

export function initLoginFailFunction() {
    window.app.handleAccountTransferredWindow = handleSocialLoginFail;
}

